<div class="dialog-container">
  <div class="page">
    <span class="page-title">Are you ready to publish the compass?</span>
    <span class="page-desc">Once the compass is published, it will show up in the list of compasses you can assign to
      patients.</span>
  </div>
  <div class="flex-page-bottom-bar">
    <div class="buttons">
      <button mat-button class="rounded-button" (click)="publish()">
        <span *ngIf="!working">Publish</span>
        <mat-progress-spinner *ngIf="working" class="spinner" mode="indeterminate" diameter="23"></mat-progress-spinner>
      </button>
    </div>
  </div>
</div>